import React, { useState, useEffect } from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import useChangePasswordPageStyles from './styles'
import { ChangePasswordNew } from '../../../../services/api'
import CustomAlert from '../../../../components/CustomAlert/CustomAlert'

const ChangePasswordPage = () => {
  const classes = useChangePasswordPageStyles()
  const token = localStorage.getItem('accessToken')
  const [oldPassword, setOldPassword] = useState('')
  const [password, setPassWord] = useState('')
  const [alertOpen, setAlertOpen] = useState(false)
  const [alertMessage, setalertMessage] = useState('')

  const handleChangepassword = () => {
    const UserId = localStorage.getItem('userId')
    if (oldPassword.length && password.length) {
      const data = {
        userId: UserId,
        oldPassword: oldPassword,
        newPassword: password,
      }
      ChangePasswordNew(data, token).then((resp) => {
        if (resp?.data) {
          setAlertOpen(true)
          setalertMessage(resp?.data?.message)
          setOldPassword('')
          setPassWord('')
        } else {
        }
      })
    } else {
    }
  }

  const alertClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setAlertOpen(false)
  }
  return (
    <div className={classes.root}>
      <CustomAlert
        handleClose={alertClose}
        open={alertOpen}
        message={alertMessage}
      />

      <div className="align_btw brdr">
        <div className="h_1">Change Password</div>
      </div>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth sx={{ m: 1 }}>
            <TextField
              id="outlined-basic"
              label="Old Password"
              variant="outlined"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth sx={{ m: 1 }}>
            <TextField
              id="outlined-basic"
              label="New Password"
              variant="outlined"
              value={password}
              onChange={(e) => setPassWord(e.target.value)}
            />
          </FormControl>
        </Grid>
      </Grid>

      <button className="save_btn" onClick={handleChangepassword}>
        Update
      </button>
    </div>
  )
}

ChangePasswordPage.propTypes = {}

export default ChangePasswordPage
